import React from 'react';
import "./loading.css";
import logoTrucktronix from '../assets/trucktronix_logo.png';
import loading from "../assets/loading.svg";

const Loading = () => {
    return (
        <svg id="loadingsvg" width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="75" r="15" stroke="#6A0BFF" strokeWidth="6">
                <animate attributeName="cy" values="100; 60; 100" dur="1s" repeatCount="indefinite" />
                <animate attributeName="opacity" values="0.3; 1; 0.3" dur="0.6s" repeatCount="indefinite" />
                <animate attributeName="stroke" values=" #6A0BFF; #FF5722; #9C27B0" dur="0.6s" repeatCount="indefinite" />
            </circle>
            <circle cx="75" cy="75" r="15" stroke=" #9C27B0" strokeWidth="6">
                <animate attributeName="cy" values="100; 60; 100" dur="1s" repeatCount="indefinite" begin="0.15s" />
                <animate attributeName="opacity" values="0.3; 1; 0.3" dur="0.6s" repeatCount="indefinite" begin="0.2s" />
                <animate attributeName="stroke" values=" #9C27B0; #FF5722; #6A0BFF" dur="0.6s" repeatCount="indefinite" begin="0.2s" />
            </circle>
            <circle cx="120" cy="75" r="15" stroke=" #6A0BFF" strokeWidth="6">
                <animate attributeName="cy" values="100; 60; 100" dur="1s" repeatCount="indefinite" begin="0.3s" />
                <animate attributeName="opacity" values="0.3; 1; 0.3" dur="0.6s" repeatCount="indefinite" begin="0.4s" />
                <animate attributeName="stroke" values=" #6A0BFF; #FF5722; #9C27B0" dur="0.6s" repeatCount="indefinite" begin="0.4s" />
            </circle>
        </svg>
    );
};

export default Loading;
